import { Autocomplete as MuiAutocomplete, AutocompleteProps } from "@mui/material"

const Autocomplete = (props: AutocompleteProps<any, any, any, any>) => (
  <MuiAutocomplete role={undefined} {...props} />
)

export default Autocomplete
